export const moduleRoutes: Record<string, string> = {
  "/dashboard": "DASHBOARD",
  "/admin": "USERS",
  "/offline-order": "ORDER",
  "/future-purchase": "FUTURE_PURCHASE",
  "/product-management": "PRODUCT",
  "/franchise": "FRANCHISE",
  "/advance-payment": "ADVANCE_PAYMENT",
  "/payments": "PAYMENTS",
  "/drawer": "DRAWER",
  "/dues":"DUES",
  "/payment-mode": "PAYMENT_MODE",
  "/user-role": "USER_ROLE",
  "/course": "COURSE",
  "/student": "STUDENT",
  "/book": "BOOK",
  "/expense-category": "EXPENSE_CATEGORY",
  "/level": "LEVEL",
  "/subject": "SUBJECT",
  "/faculty": "FACULTY",
  "/mode": "MODE",
  "/course-type": "COURSE_TYPE",
  "/attempt": "ATTEMPT",
};
